module.exports = __webpack_public_path__ + "static/media/about7-01.54e2c858.png";